export const hasPostOfficeBox = (address: string): boolean =>
  PO_BOX_PATTERNS.some((pattern) => address.toLowerCase().includes(pattern));

export const PO_BOX_PATTERNS = [
  'p o box',
  'p.o. box',
  'p.o.b.',
  'p.o.box',
  'po box',
  'pobox',
  'post office box',
];
